
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { ProjectSection } from './components/ProjectSection';
import { InvestmentSection } from './components/InvestmentSection';
import { TeamSection } from './components/TeamSection';
import { TimelineSection } from './components/TimelineSection';
import { InvestorBenefitsSection } from './components/InvestorBenefitsSection';
import { FAQSection } from './components/FAQSection';

const CrowdfundingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <ProjectSection />
        <InvestmentSection />
        <InvestorBenefitsSection />
        <TeamSection />
        <TimelineSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default CrowdfundingPage;
